import { marked } from "marked";
import { DOCS_LEGACY_ROUTE, DOCS_ROUTE, docsHref } from "./docsCatalog";

marked.setOptions({ gfm: true, breaks: false });

function slugify(text) {
  return text
    .normalize("NFD")
    .replace(/\p{Diacritic}/gu, "")
    .toLowerCase()
    .replace(/[^\p{L}\p{N}]+/gu, "-")
    .replace(/^-+|-+$/g, "");
}

function escapeAttr(value) {
  return value.replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/</g, "&lt;");
}

function resolveRelative(fromId, rel) {
  let target = rel.split("?")[0];
  try {
    target = decodeURIComponent(target);
  } catch {
    /* keep raw */
  }
  target = target.replace(/\\/g, "/");
  if (target.startsWith("/")) return target.replace(/^\/+/, "");

  const fromDir = fromId.includes("/") ? fromId.slice(0, fromId.lastIndexOf("/")) : "";
  const joined = fromDir ? `${fromDir}/${target}` : target;
  const parts = [];
  for (const seg of joined.split("/")) {
    if (!seg || seg === ".") continue;
    if (seg === "..") {
      parts.pop();
      continue;
    }
    parts.push(seg);
  }
  return parts.join("/");
}

export function rewriteDocsHref(fromId, href) {
  const trimmed = href.trim();
  if (!trimmed || trimmed.startsWith("#") || /^(https?:|mailto:|tel:)/i.test(trimmed)) {
    return trimmed;
  }
  if (
    trimmed.startsWith(DOCS_ROUTE) ||
    trimmed.startsWith(DOCS_LEGACY_ROUTE) ||
    trimmed.startsWith("?doc=")
  ) {
    return trimmed;
  }

  const hashIndex = trimmed.indexOf("#");
  const pathPart = hashIndex >= 0 ? trimmed.slice(0, hashIndex) : trimmed;
  const hash = hashIndex >= 0 ? trimmed.slice(hashIndex) : "";
  if (!pathPart) return trimmed;

  const resolved = resolveRelative(fromId, pathPart);
  if (!resolved.toLowerCase().endsWith(".md")) return trimmed;
  return docsHref(resolved, hash);
}

function addHeadingIds(html) {
  return html.replace(/<h([1-6])>([\s\S]*?)<\/h\1>/g, (_full, level, inner) => {
    const plain = inner.replace(/<[^>]+>/g, "").trim();
    const id = slugify(plain);
    if (!id) return `<h${level}>${inner}</h${level}>`;
    return `<h${level} id="${escapeAttr(id)}">${inner}</h${level}>`;
  });
}

function decorateExternalLinks(html) {
  return html.replace(/<a href="(https?:[^"]+)"/g, '<a href="$1" target="_blank" rel="noopener noreferrer"');
}

export function renderDocsHtml(markdown, fromId) {
  const tokens = marked.lexer(markdown);
  marked.walkTokens(tokens, (token) => {
    if ((token.type === "link" || token.type === "image") && token.href) {
      token.href = rewriteDocsHref(fromId, token.href);
    }
  });
  const html = marked.parser(tokens);
  return decorateExternalLinks(addHeadingIds(html));
}
